module.exports = __webpack_public_path__ + "static/media/googlePlay.f996d403.svg";